export enum BasicsRegistrationFormTestId {
    FirstNameField = 'RegistrationBasicsFormTestId.FirstNameField',
    LastNameField = 'RegistrationBasicsFormTestId.LastNameField',
    DateField = 'RegistrationBasicsFormTestId.DateField',
    Company = 'RegistrationBasicsFormTestId.Company',
    EmailField = 'RegistrationBasicsFormTestId.EmailField',
    SSOButton = 'RegistrationBasicsFormTestId.SSOButton',
    HelpLink = 'RegistrationBasicsFormTestId.HelpLink',
}

export enum RegistrationFormTestId {
    FirstNameField = 'RegistrationFormTestId.FirstNameField',
    LastNameField = 'RegistrationFormTestId.LastNameField',
    Company = 'RegistrationFormTestId.Company',
    EmailField = 'RegistrationFormTestId.EmailField',
    PasswordField = 'RegistrationFormTestId.PasswordField',
    ConfirmPasswordField = 'RegistrationFormTestId.ConfirmPasswordField',
    TermsCheckBox = 'RegistrationFormTestId.TermsCheckBox',
    PrivacyCheckBox = 'RegistrationFormTestId.PrivacyCheckBox',
    HipaaCheckBox = 'RegistrationFormTestId.HipaaCheckBox',
    PersonalHealthInfoCheckBox = 'RegistrationFormTestId.PersonalHealthInfoCheckBox',
}

export enum LoginFormTestId {
    EmailField = 'LoginFormTestId.EmailField',
    OldEmailField = 'LoginFormTestId.OldEmailField',
    PasswordField = 'LoginFormTestId.PasswordField',
    OldPasswordField = 'LoginFormTestId.OldPasswordField',
    ContinueButton = 'LoginFormTestId.ContinueButton',
    BackButton = 'LoginFormTestId.BackButton',
    SSOButton = 'LoginFormTestId.SSOButton',
    ForgotPasswordButton = 'LoginFormTestId.ForgotPasswordButton',
    ErrorMessage = 'LoginFormTestId.ErrorMessage',
}

export enum ConsentTestId {
    PrivacyPolicyTestId = 'ConsentTestId.PrivacyPolicyTestId',
    PrivacyPolicyEuroTestId = 'ConsentTestId.PrivacyPolicyEuroTestId',
    PersonalHealthInfoTestId = 'ConsentTestId.PersonalHealthInfoTestId',
    TosEngTestId = 'ConsentTestId.TosEngTestId',
    HipaaTestId = 'ConsentTestId.HipaaTestId',
}

export enum ConsentTermsKoreaTestId {
    AcceptAllKoreaTermsCheckBox = 'RegistrationFormTestId.AcceptAllKoreaTermsCheckBox',
    UseSensitiveInfoCheckBox = 'RegistrationFormTestId.UseSensitiveInfoCheckBox',
    ProvisionOfPersonalInfoUseAccepted = 'RegistrationFormTestId.ProvisionOfPersonalInfoUseAccepted',
    OverseasPersonalInfoXferAccepted = 'RegistrationFormTestId.OverseasPersonalInfoXferAccepted',
    CollectPersonalInfoForMarketingAccepted = 'RegistrationFormTestId.CollectPersonalInfoForMarketingAccepted',
    FirstUrl = 'RegistrationFormTestId.FirstUrl',
    SecondUrl = 'RegistrationFormTestId.SecondUrl',
}

export enum ConsentTextKoreaTestId {
    AcceptAllTestId = 'ConsentTestId.AcceptAllTestId',
    TosKoreaTestId = 'ConsentTestId.TosKoreaTestId',
    CollectionAndUseOfPersonalInfoTestId = 'ConsentTestId.CollectionAndUseOfPersonalInfoTestId',
    CollectionAndUseOfSensitiveInfoTestId = 'ConsentTestId.CollectionAndUseOfSensitiveInfoTestId',
    ProvisionOfPersonalInfoToThirdPartiesTestId = 'ConsentTestId.ProvisionOfPersonalInfoToThirdPartiesTestId',
    OverseasTransferOfPersonalInfoTestId = 'ConsentTestId.OverseasTransferOfPersonalInfoTestId',
    OptionalCollectionAndUseOfPersonalInfoForMarketingTestId = 'ConsentTestId.OptionalCollectionAndUseOfPersonalInfoForMarketingTestId',
}
